export const delegation_of_authority_computed = {
    active_drawer() {
      return this.drawer_catalog[this.active_drawer_key] || null;
    },
    active_modal() {
      return this.active_modal_data || null;
    },
    active_drawer_footer_primary_actions() {
      const actions = this.active_drawer?.footer_actions || [];
      const has_explicit_positions = actions.some((action) => action.position);

      if (!has_explicit_positions) {
        return [];
      }

      return actions.filter((action) => action.position === 'left');
    },
    active_drawer_footer_actions() {
      const actions = this.active_drawer?.footer_actions || [];
      const has_explicit_positions = actions.some((action) => action.position);

      if (!has_explicit_positions) {
        return actions;
      }

      return actions.filter((action) => action.position !== 'left');
    }
};

